export default __webpack_public_path__ + "static/media/Piramide.c5faa3f0.jpg";